<template>
  <v-select
    clearable
    outlined
    required
    dense
    offset-y
    hide-details
    prepend-inner-icon="mdi-calendar-outline"
    item-value="value"
    :menu-props="{
      bottom: true,
      offsetY: true,
    }"
    :value="initialDay"
    :items="days"
    :label="$t('routines_reminder.day')"
    :placeholder="$t('routines_reminder.day')"
    @change="$emit('change', $event)"
  />
</template>
<script>
import moment from 'moment'

export default {
  name: 'DaySelector',
  props: {
    initialDay: {
      type: [Number, String],
    },
    initialDate: { type: String },
  },
  data() {
    return {
      days: [],
    }
  },

  mounted() {
    this.createDaysList()
  },

  watch: {
    initialDate() {
      this.createDaysList()
    },
  },

  methods: {
    createDaysList() {
      const startDay = moment(this.initialDate).startOf('month')
      const endDay = moment(this.initialDate).endOf('month')
      const interval = 1

      const daysList = []
      let currentDay = moment(startDay)

      while (currentDay.isSameOrBefore(endDay, 'day')) {
        daysList.push({
          value: currentDay.date(),
          text: this.$t('routines_reminder.day_number', {
            number: currentDay.date(),
          }),
        })

        currentDay.add(interval, 'days')
      }

      daysList.push({
        value: 'last_day',
        text: this.$t('routines_reminder.last_day'),
      })

      this.days = daysList
    },
  },
}
</script>
